import React, { createContext, useState } from 'react';

import OtsPositionWorkedEvaluationLevelEvaluatorNameData from './OtsPositionWorkedEvaluationLevelEvaluatorNameData';

export const OtsPositionWorkedEvaluationLevelEvaluatorNameStateContext = createContext();

const OtsPositionWorkedEvaluationLevelEvaluatorNameContextProvider = ({ children }) => {
  const stateHook = useState(OtsPositionWorkedEvaluationLevelEvaluatorNameData.INITIAL_STATE);

  return (
    <OtsPositionWorkedEvaluationLevelEvaluatorNameStateContext.Provider value={stateHook}>
      {children}
    </OtsPositionWorkedEvaluationLevelEvaluatorNameStateContext.Provider>
  );
};

export default OtsPositionWorkedEvaluationLevelEvaluatorNameContextProvider;